module.exports = "https://portperrypedals.ca/_res/img/oldflame.7b7ac0d.png";